module.exports = __webpack_public_path__ + "static/media/dial_legend_comsumption_estimate.62be5253.svg";